import { CreditScore } from '@/catalog/types/credit-score';
import { DrawerDialog, DrawerDialogProps } from '@/common/components/drawer-dialog';
import Spacer from '@/common/components/spacer';
import StatusBanner from '@/common/components/status-banner';
import StepCreditAge from './intro-modal/step-credit-age';
import { AgeRange } from '../types/age-range';

export interface PreviewYourRatesDrawerDialogProps extends DrawerDialogProps {
  selectedCreditScoreId?: string;
  selectedIsOver25?: boolean;
  creditScores: CreditScore[];
  selectedAgeRangeId?: string;
  ageRanges?: AgeRange[];
  error?: string;
  alreadyQualified?: boolean;
}

export default function PreviewYourRatesDrawerDialog({
  selectedCreditScoreId,
  selectedIsOver25,
  creditScores,
  ageRanges,
  selectedAgeRangeId,
  open,
  error,
  handleClose,
  alreadyQualified,
}: PreviewYourRatesDrawerDialogProps) {
  return (
    <DrawerDialog
      open={open}
      handleClose={handleClose}
      dismissible={selectedCreditScoreId !== undefined}
      title="About you"
    >
      {error ? (
        <>
          <StatusBanner
            variant="error"
            message={{
              text: error,
            }}
            shouldScrollToTop={true}
          />
          <Spacer variant="height16" />
        </>
      ) : null}
      <StepCreditAge
        selectedCreditScoreId={selectedCreditScoreId}
        creditScores={creditScores}
        selectedIsOver25={selectedIsOver25 ?? true}
        selectedAgeRangeId={selectedAgeRangeId}
        ageRanges={ageRanges}
        isOpenedFromInventory={false}
        alreadyQualified={alreadyQualified}
      />
    </DrawerDialog>
  );
}
